module.exports = __webpack_public_path__ + "img/icon-play--green.d65ccb5b.svg";